import { useAppDispatch, useAppSelector } from 'common';
import { PrivateUserUpdate } from 'common/src/api/models/recipe-header-private-user.models';
import {
  getRecipeCustomerUserManages,
  getRecipeSharedUsers,
  selectAllRecipeCustomerUserManages,
  selectAllRecipeUsers,
  updateRecipeCustomerUserManages,
} from 'common/src/store/recipes';
import { useEffect } from 'react';
import { getResolution } from '../../../../utilities/resolution';
import UserCheckboxDialog from '../UserCheckboxDialog/UserCheckboxDialog';

export type RecipeManageUsersDialogProps = {
  customerId: string;
  onClose: () => void;
};

export default function RecipeManageUsersDialog(props: RecipeManageUsersDialogProps): JSX.Element {
  const dispatch = useAppDispatch();

  const manageUsers = useAppSelector((s) => selectAllRecipeCustomerUserManages(s.recipes.recipeCustomerUserManages));
  const isManageUsersLoading = useAppSelector((s) => s.recipes.isRecipeCustomerUserManagesLoading);
  const recipeUsers = useAppSelector((s) => selectAllRecipeUsers(s.recipes.recipeUsers));
  const isRecipeUsersLoading = useAppSelector((s) => s.recipes.isLoadingRecipeUsers);

  useEffect(() => {
    dispatch(getRecipeCustomerUserManages(props.customerId));
    dispatch(getRecipeSharedUsers(props.customerId));
  }, [props.customerId]);

  const handleSubmit = (users: PrivateUserUpdate[]) => {
    const request = {
      UserUpdates: users,
      CustomerId: props.customerId,
    };

    dispatch(updateRecipeCustomerUserManages(request, getResolution()));
    props.onClose?.();
  };

  return (
    <UserCheckboxDialog
      title='Manage recipe editors'
      onClose={props.onClose}
      onSubmit={handleSubmit}
      isLoading={isRecipeUsersLoading || isManageUsersLoading}
      users={recipeUsers}
      defaultCheckedUsers={manageUsers.map((u) => u.UserId)}
      subTitleOverride='Select users from shared locations to enable/disable editing of all recipes.'
    />
  );
}
